module.exports = __webpack_public_path__ + "static/media/cookie.ed7f7b93.png";